module.exports = __webpack_public_path__ + "static/teacher_videos-ceb9c26d387e8602e35ee78532cbaba1.jpg";